module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("They Call Me Mellow Yellow (Quite Rightly)")])])]), _vm._v(" "), _c('p', {
    staticClass: "DLF"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("8:24 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Five minutes later, we pull into the school parking lot. I must have spent too long idling in Owen’s driveway griping about my fight with Tristan, because the only spots left are in the farthest row. It’s not until I open the car door and see a splotch of rain hit my cardigan that I remember I don’t have an umbrella.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You don’t happen to have an umbrella, do you?” I call to Owen. He’s already out of the car, tilting his head back to catch rainwater in his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I thought you’d bring one,” he says without looking at me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I groan. “I didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Ouch. And with school pictures today?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dang it.")]), _vm._v(" I’d already forgotten about that. To be honest, I’m more worried about seeing Tristan than I am about my picture. Drowned Rat is not exactly the look I was going for when I give my big apology speech.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Speech.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Crap! I have to give my election speech today, too. This day is "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("so")]), _vm._v(" not turning out the way I’d hoped. So much for good vibrations.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I grab my schoolbag from the backseat and hold it up as a shield above my head. “You don’t seem too worried about "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("your")]), _vm._v(" school picture.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He shrugs. “I’m a dude. My hair always looks good.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I hate to admit it, but it’s true. Owen could go through a car wash in a convertible and still come out the other end looking like he spent an hour in front of the mirror. Guys have it so much easier.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I lock the car and walk around to his side. Owen laughs at my makeshift umbrella. “Run for it?” he suggests.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I nod, and we take off into the rain.")]), _vm._v(" "), _c('p', {
    staticClass: "DL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("8:42 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("“Say ‘Two more years!’” the overly cheerful photographer chirps.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I give a weak smile and she takes the picture.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Why do people tell you to say stupid things when they’re taking your photo? I mean, beyond the age of three when you’re required to say “cheese” to ensure you’re not scowling or sticking out your tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Does this woman seriously think I’m going to say “two more years” for my school photo? Does she not realize what the word “years” would do to my lips? It would make me look like I was sucking face with an octopus.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Lovely,” she lies, and then calls, “Next!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I scoot off the stool and walk to the other end of the cafeteria where the rest of Mr. Briggs’s chemistry class is waiting. Of course we would be the first group called in for photos. I didn’t have a single spare moment to go to the bathroom to fix my hair. By the time Owen and I made it in from the rain, the first-period warning bell was already ringing and I had to head straight to class.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I manage to catch a peek at the photographer’s viewfinder as I pass, and oh my God, it’s more horrifying than I thought. My eyes are totally bloodshot from the rain. My makeup has smeared. My hair looks stringy and limp, like a kindergartner attached it to my head with Elmer’s glue.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fortunately I won’t see Tristan until next period, and I should have time to duck into the bathroom and touch up before then. I need to look perfect when I see him. Or, at the very least, presentable.")]), _vm._v(" "), _c('p', {
    staticClass: "DL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("9:50 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("As soon as the bell rings, I jam my earbuds into my ears and scroll through my playlists until I find the one I want. “Mood Altering Substances.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The soothing sound of Donovan crooning “Mellow Yellow” floods into my ears and I feel myself relax somewhat. I keep my head down as I navigate through the crowd toward the girls’ bathroom, but a tap on my shoulder makes me jump. I spin around to find—")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oh, please no.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This is not happening. It was not supposed to go down like this. I was supposed to look breezy and happy-go-lucky and, above all else, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("nonfrightening")]), _vm._v(" when I first saw him today. Not like I just walked out of the House of Horrors.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I rip my earbuds out and do my best to sound cheerful. “Tristan!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("God, he looks gorgeous today. His dark blond hair is all tousled and oh-so-touchable. He’s wearing the faded loose-fit jeans and black leather jacket combo that I love. Although to be fair, he pretty much wears that every day.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He’s staring at my face like he’s trying to decipher an ancient Egyptian scroll. “Are you trying out for the play?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Ouch")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I dab uselessly at the skin under my eyes. “No. I was just … it was the rain. I didn’t bring an umbrella. I was on my way to the bathroom to clean up.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Remember. You are drama free. You are the embodiment of chill.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I mean, not that I "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("care")]), _vm._v(",” I add quickly. “What’s a little rain, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Right,” he agrees, hitching the strap of his guitar case up his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I just hope it clears up before tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Confusion is back on his face. “What’s tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I wince inwardly. Did he forget?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The town carnival?” I remind him. “Tonight’s the last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’ve only been looking forward to it since I was ten years old. Okay, so I didn’t actually "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("know")]), _vm._v(" Tristan when I was ten. He moved to our town freshman year. The carnival comes to town every year for two weeks. I’ve been going to it since I was a kid, and when I was ten I saw this couple there who looked so head-over-heels in love with each other, I kind of became obsessed with them. I followed them around all night, tracking their date like a private investigator.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I looked on whimsically as they held hands in line for the rides. I smiled a goofy smile as he won her the biggest stuffed animal at the ring toss game. I swooned when they sat down to share a milk shake and he reached across the table to cup her face in his hands, like he was trying to hold her together. I got a crick in my neck following their progress on the Ferris wheel (a ride I’ve still never gone on due to my paralyzing fear of heights). Then, when their car paused at the top and they shared a moonlight kiss, all I could think was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I want that")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I want to be in love like that.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("To this day, it’s the most romantic thing I’ve ever witnessed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But until five months ago, I’d never actually had a boyfriend to go to the carnival with.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We’re still going, right?” I ask, cringing at how whiny my voice sounds. Maybe I really "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("am")]), _vm._v(" turning into a drama queen.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He nods, but I can tell his mind is elsewhere. “Sure. Sounds fun.” He clears his throat. “So, that thing. Last night. I thought we could talk about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oh God, he wants to do this")]), _vm._v(" now"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Here? While I’m looking like")]), _vm._v(" this"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I take a deep breath. Time to defuse a bomb. “Yeah, I wanted to talk about it, too. Look, I’m so sorry about that. I completely overreacted. It’s all my fault. And I’ll totally buy your mom a new garden gnome.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This makes him smile and I feel my throat loosening.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Am I doing it? Am I smoothing things over?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I charge on, talking so fast I barely even know what I’m saying anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I was hungry. And tired. And stressed about the election today. I really think that’s what it was. You know, I’m not usually like that. I’m usually totally fine with all the girls. I mean, I "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("am")]), _vm._v(" fine with all the girls. I mean, not like for you to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("make out")]), _vm._v(" with them or anything. But you know, talking to them and doing your … rock star thing.” I raise my hands in the air and wiggle my fingers to illustrate my point.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Wait. Did I just do jazz hands?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Moving on.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I wish we could forget the whole thing and pretend like it didn’t happen. And—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh, yeah,” he interrupts, his expression shifting to something unreadable. “I forgot about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The election. That’s today, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Is he still hung up on that part? How fast was I talking?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes. There’s a school assembly during homeroom. I have to give my speech.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He taps his fingers against the strap of his case. “Huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Huh?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What does “huh” mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So do you think we can do that?” I ask, pressing on. “Forget this whole thing ever happened and start fresh? I’m really, really sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The bell rings.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We better get to class,” Tristan says.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Was that a yes?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He grabs my hand and interlaces his fingers with mine. The warmth of his flesh does more to calm me than any song in any of my stupid playlists. I want to live inside those beautiful strong hands of his. Sometimes when I watch him strum his guitar on stage, or when he’s practicing with the band, I get lost in the movement of his fingers. Like I’m in a trance.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And don’t get me started on his wrists.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As we walk hand in hand toward Spanish class, I almost manage to forget the atrocity that is my face. That is, until we step inside the classroom and Señora Mendoza does a double take in my direction. Then she shakes her head, as if to say, “Kids these days! Who can understand them?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We take our usual seats in the back row as Señora Mendoza starts conjugating the future tense of the verb "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ver")]), _vm._v(" on the whiteboard. I pull a piece of notebook paper from my binder, scribble “Are we good?” and slide it onto Tristan’s desk.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He glances down, then winks at me, causing my heart to puddle on the floor. “Yeah,” he whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But there’s something about the way he turns his attention back to the front of the class—the speed at which he breaks eye contact—that makes me doubt the sincerity of the word. Am I being paranoid or has he suddenly taken a very unusual interest in Spanish verb conjugations?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then just as Señora Mendoza is in the middle of saying "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Nosotros veremos”")]), _vm._v("—we will see—a loud "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("thunk")]), _vm._v(" startles me out of my thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The entire class turns toward the window as a giant black bird slides down the glass and drops to the ground outside.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“¡Dios mío!”")]), _vm._v(" Señora Mendoza cries, holding her hand to her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Is it dead?” someone asks, racing to the window along with a handful of other students.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s totally dead,” Sadie Haskins replies.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And that’s all it takes for me to burst into tears.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eef91ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 87
// module chunks = 0